import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class WebsiteInfoService extends BaseService {

    static url = "values";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("values");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: WebsiteInfoService.apis.getAll.path,
                    method: WebsiteInfoService.apis.getAll.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default WebsiteInfoService;